module.exports = __webpack_public_path__ + "static/gallery-5@2x-2798e02d7322ee43b22742466a399a90.jpg";